import type {
  Decimal,
  DecimalInputProps
} from '@healthnz-prm/fhir-engine-renderer/types'
import { InputFieldset } from '../inputFieldset'
import { InputDecimal } from './InputDecimal'

export function DecimalInput(props: DecimalInputProps) {
  const { inputId, onBlur, onChange, onFocus, value } = props

  function handleChange(newValue: string) {
    const parsed = newValue === '' ? null : Number.parseFloat(newValue)
    onChange(parsed as Decimal)
  }

  const inputValue =
    value === null || !Number.isFinite(value) ? undefined : value.toString()

  return (
    <InputFieldset {...props}>
      <InputDecimal
        id={inputId}
        name={inputId}
        value={inputValue}
        onChange={handleChange}
        onBlur={onBlur}
        onFocus={onFocus}
      />
    </InputFieldset>
  )
}
